import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { getEventVehiclesByEventIdAsync, getEventVehicleByIdAsync, createEventVehicleAsync, updateEventVehicleAsync, deleteEventVehicleAsync, getRouteVehiclesByPickupLocationAsync, getEventVehiclesNotPaginatedByEventIdAsync } from './eventVehicleThunk';
const initialState = {
    status: APIStatus.IDLE,
    vehicles: null,
    vehiclesNotPaginated: [],
    vehicle: undefined,
    vehiclesByLocation: []
};
export const eventVehicleSlice = createSlice({
    name: 'eventVehicle',
    initialState,
    reducers: {
        resetEventVehicleStatus: (state) => {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEventVehiclesByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEventVehiclesByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.vehicles = action.payload;
        })
            .addCase(getEventVehiclesByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(getEventVehiclesNotPaginatedByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEventVehiclesNotPaginatedByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.vehiclesNotPaginated = action.payload;
        })
            .addCase(getEventVehiclesNotPaginatedByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getEventVehicleByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEventVehicleByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.vehicle = action.payload;
        })
            .addCase(getEventVehicleByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createEventVehicleAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createEventVehicleAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (state.vehicles) {
                state.vehicles.items = [action.payload, ...state.vehicles.items];
                state.vehicles.totalCount += 1;
            }
        })
            .addCase(createEventVehicleAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateEventVehicleAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateEventVehicleAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (state.vehicles) {
                state.vehicles.items = state.vehicles.items.map((v) => v.id === action.payload.id ? action.payload : v);
            }
            state.vehicle = action.payload;
        })
            .addCase(updateEventVehicleAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteEventVehicleAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteEventVehicleAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(deleteEventVehicleAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getRouteVehiclesByPickupLocationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getRouteVehiclesByPickupLocationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.vehiclesByLocation = action.payload;
        })
            .addCase(getRouteVehiclesByPickupLocationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { resetEventVehicleStatus } = eventVehicleSlice.actions;
export default eventVehicleSlice.reducer;
